module.exports = __webpack_public_path__ + "static/media/17a-02_ST-2017-280x350cm-oleo-sobre-madera.26b66eac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/17a/17a-02_ST-2017-280x350cm-oleo-sobre-madera.jpg
// module id = 205
// module chunks = 0